
(() => {
  const body = document.body;
  const hero = document.querySelector('[id^="VaultHomeHero-"]');
  if (hero) {
    const eyebrow = hero.querySelector('.vault-home-hero__eyebrow');
    const title = hero.querySelector('.vault-home-hero__title');
    const text = hero.querySelector('.vault-home-hero__text p');
    const actions = hero.querySelectorAll('.vault-home-hero__actions a');
    if (eyebrow) eyebrow.textContent = 'Welcome to the Vault';
    if (title) title.textContent = 'A home for every kind of tabletop story.';
    if (text) text.textContent = 'Build a campaign, paint an army, open a new deck, find the perfect figure, or simply stay awhile among people who love the hobby too.';
    if (actions[0]) {
      actions[0].textContent = 'Explore the Vault';
      actions[0].href = '/collections/fantasy-ttrpg';
    }
    if (actions[1]) {
      actions[1].textContent = 'Join the Community';
      actions[1].href = 'https://discord.gg/PqHeJErB5Q';
    }
  }
  const updateHeader = () => body.classList.toggle('vod-has-scrolled', window.scrollY > 16);
  updateHeader();
  window.addEventListener('scroll', updateHeader, { passive: true });

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const targets = document.querySelectorAll(
    '[id^="VaultHomeLanes-"], [id^="VaultHomeGuides-"], .vault-home-articles, .collection .product-grid > li, .product__media-item, .footer-block'
  );
  if (!('IntersectionObserver' in window)) return;
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('vod-refine-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: .06 });
  targets.forEach((target, index) => {
    target.classList.add('vod-refine-reveal');
    target.style.transitionDelay = `${Math.min(index % 4, 3) * 55}ms`;
    observer.observe(target);
  });
})();
